<template>
    <div class="card">
        <div class="card-header">
            <h5 class="m-0">Artiklar per månad</h5>
        </div>
        <div class="card-body">
            <apexcharts width="100%"  height="350"
                type="bar"
                :options="options"
                :series="series"></apexcharts>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import VueApexCharts from "vue-apexcharts";

export default {
    components: {
        apexcharts: VueApexCharts
    },
    props : ['company'],
    data() {
        return {
            options: {
                plotOptions: {
                    bar: {
                        columnWidth: '20%',
                        distributed: true,
                        endingShape: 'rounded',
                    }
                },
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    categories: [],
                },
                fill: {
                    colors: ['#666EE8']
                }
            },
            series: [{
                data: []
            }]
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        parseData(data){
            let options = this.options;

            data.map(post => {
                var month = this.moment(post.month,"YYYY/MM").format('MMMM');
                options.xaxis.categories.push(month);
                
                this.series[0].name = "artiklar";
                this.series[0].data.push(post.count);
            });
        },
        async fetchData() {
            const { data } = await axios.get(
                "api/analytics/printables_by_month?company_id=" + this.company
            );

            this.parseData(data);
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/PrintableMonths.vue